import type { MediaGeneratorKey, MediaProvider } from '@mg/shared';

/**
 * The generators Generate media may offer: the built-in FLUX only while it is switched on, then the BYO
 * providers with a key. Order = dropdown order; the first is the fallback.
 *
 * "Switched on" is the install's image generation (App Settings → AI models, else
 * AZURE_OPENAI_DEPLOYMENT_IMAGE), as `useDesignTools().builtInImageGeneration` reports it. While it is
 * off, the server refuses every built-in generation, so offering FLUX would only produce that refusal.
 */
export function generatorChoices(builtInOn: boolean, byo: MediaProvider[]): MediaGeneratorKey[] {
  return builtInOn ? ['azure', ...byo] : [...byo];
}
